import { CEST } from "../central-operacional";

export class FiltroLaudo {
	codigo?: number;
	codigoSiatSistec?: string;
	sicadCpfCnpjCliente?: number;
	nomeCliente?: string;
	fase?: number;
	dataInicial?: Date | null;
	dataFinal?: Date | null;
	cest?: CEST;
	openFiltro?: boolean;
	tipoRestricaoDocumento?: string;
	redirecionadoHome?: boolean;
	codsLaudos?: number[];
	codsSituacoes?: number[] = [];
	mesAno?: string;
	ano?: number;
	codsTipoLaudo?: number[];
}
